import { render, staticRenderFns } from "./ProtocolNode.vue?vue&type=template&id=789a438e&scoped=true&"
import script from "./ProtocolNode.vue?vue&type=script&lang=js&"
export * from "./ProtocolNode.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolNode.vue?vue&type=style&index=0&id=789a438e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a438e",
  null
  
)

export default component.exports